import {
	COMPANY_OTHER_LIST_FILTER_NAME,
	COMPANY_OTHER_LIST_FILTER_PARAM,
} from "@signalist/shared-types";

import { FilterCategory } from "../enums/filter.enum";

import { inCampaign } from "./in-campaign-filter";

import type { IFilter } from "./filter-types";

export * from "./filter-types";

const overallScore: IFilter = {
	name: "overallScore",
	filterParam: "score_persona_category_result.overallScore",
	filterByType: ["isEmpty", "isNotEmpty", "dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

const companyCategory: IFilter = {
	name: "companyCategory",
	filterParam: "score_persona_category_result.scoreCompanyCategoryId",
	subSelectFilterParam: "score_persona_category_result.scoreCompanyCategoryId",
	filterByType: ["isEmpty", "isNotEmpty", "dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.LEAD_CATEGORIZATION_AND_SCORING,
};

const companyCategoryType: IFilter = {
	name: "companyCategoryType",
	filterParam: "score_company_category.type",
	subSelectFilterParam: "score_company_category.type",
	filterByType: ["isEmpty", "isNotEmpty", "dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.LEAD_CATEGORIZATION_AND_SCORING,
};

const personaCategory: IFilter = {
	name: "personaCategory",
	filterParam: "score_persona_category_result.scorePersonaCategoryId",
	subSelectFilterParam: "score_persona_category_result.scorePersonaCategoryId",
	filterByType: ["isEmpty", "isNotEmpty", "dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.LEAD_CATEGORIZATION_AND_SCORING,
};

const language: IFilter = {
	name: "language",
	filterParam: "prospect.language",
	filterByType: ["isEmpty", "isNotEmpty", "textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const exclusionReason: IFilter = {
	name: "exclusionReason",
	filterParam: "exclusion_reason.reason",
	subSelectFilterParam: "exclusion_reason.reason",
	filterByType: ["isEmpty", "isNotEmpty", "textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const name: IFilter = {
	name: "name",
	filterParam: "prospect.name",
	filterByType: ["textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const email: IFilter = {
	name: "email",
	filterParam: "prospect.email",
	filterByType: ["isEmpty", "isNotEmpty", "textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

const previousEmployer: IFilter = {
	name: "previousEmployer",
	filterParam: "apollo_person_employment.organizationName",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const connections: IFilter = {
	name: "connections",
	filterParam: "user_prospect.userId",
	subSelectFilterParam: "user_prospect.userId",
	filterByType: ["dropdown", "dropdownExclude", "isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

const linkedinUrl: IFilter = {
	name: "linkedinUrl",
	filterParam: "prospect.linkedinUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

export const country: IFilter = {
	name: "country",
	filterParam: "prospect.country",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

const city: IFilter = {
	name: "city",
	filterParam: "prospect.city",
	filterByType: ["dropdownCustom", "dropdownCustomExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const state: IFilter = {
	name: "state",
	filterParam: "prospect.state",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const company: IFilter = {
	name: "companyName",
	filterParam: "organization.name",
	filterByType: [
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const cityBranch: IFilter = {
	name: "cityBranch",
	filterParam: "organization.city",
	filterByType: ["dropdownCustom", "dropdownCustomExclude", "isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const stateBranch: IFilter = {
	name: "stateBranch",
	filterParam: "company_location.state",
	filterByType: ["dropdown", "dropdownExclude", "isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const countryBranch: IFilter = {
	name: "countryBranch",
	filterParam: "company_location.country",
	filterByType: ["dropdown", "dropdownExclude", "isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const companyCountry: IFilter = {
	name: "companyCountry",
	filterParam: "organization.country",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

export const companyState: IFilter = {
	name: "companyState",
	filterParam: "organization.state",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const companyCity: IFilter = {
	name: "companyCity",
	filterParam: "organization.city",
	filterByType: ["dropdownCustom", "dropdownCustomExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const companyLinkedinUrl: IFilter = {
	name: "companyLinkedinUrl",
	filterParam: "organization.linkedinUrl",
	filterByType: ["textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const foundedYear: IFilter = {
	name: "foundedYear",
	filterParam: "organization.foundedYear",
	filterByType: ["isEmpty", "isNotEmpty", "greaterEqual", "lessEqual", "between"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const branchesWorldwide: IFilter = {
	name: "branchesWorldwide",
	filterParam: "prospect->organization->companyLocations.country",
	filterByType: ["greaterEqual", "lessEqual"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const branchesInEuropeanUnion: IFilter = {
	name: "branchesInEuropeanUnion",
	filterParam: "prospect->organization->companyLocations.country",
	filterByType: ["greaterEqual", "lessEqual"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const branchesInEasternGermany: IFilter = {
	name: "branchesInEasternGermany",
	filterParam: "prospect->organization->companyLocations.country",
	filterByType: ["greaterEqual", "lessEqual"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const branchesInSaxony: IFilter = {
	name: "branchesInSaxony",
	filterParam: "prospect->organization->companyLocations.country",
	filterByType: ["greaterEqual", "lessEqual"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const about: IFilter = {
	name: "about",
	filterParam: "prospect.about",
	filterByType: ["textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const title: IFilter = {
	name: "title",
	filterParam: "prospect.title",
	filterByType: ["dropdownCustom", "dropdownCustomExclude"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

const seniority: IFilter = {
	name: "seniority",
	filterParam: "job_title_to_seniority.seniority",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

export const website: IFilter = {
	name: "website",
	filterParam: "organization.websiteUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const industry: IFilter = {
	name: "industry",
	filterParam: "organization.industry",
	filterByType: ["dropdown", "dropdownExclude", "isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const estimatedNumEmployees: IFilter = {
	name: "estimatedNumEmployees",
	filterParam: "organization.estimatedNumEmployees",
	filterByType: ["isEmpty", "isNotEmpty", "greaterEqual", "lessEqual", "between"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const reportedEmployees: IFilter = {
	name: "reportedEmployees",
	filterParam: "organization.employeesFrom",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

export const genderProbability: IFilter = {
	name: "genderProbability",
	filterParam: "prospect.genderProbability",
	filterByType: ["isEmpty", "isNotEmpty", "greaterEqual", "lessEqual", "between"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const event: IFilter = {
	name: "event",
	filterParam: "li_event_entry.name",
	filterByType: ["dropdown", "textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.EVENTS,
};

export const list: IFilter = {
	name: "list",
	filterParam: "list_other.name",
	subSelectFilterParam: "list_person.prospectId",
	filterByType: ["dropdown", "dropdownExclude", "isIn", "isNotIn"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

/**
 * "Company is on other list" (PREC-4447): another list of the workspace holds a lead of this lead's
 * company — the question the "Company on other lists" column answers. "Is not empty" means any
 * other list, "Is in" one of the picked lists; a lead whose company is unknown matches neither side.
 */
export const companyOtherList: IFilter = {
	name: COMPANY_OTHER_LIST_FILTER_NAME,
	filterParam: COMPANY_OTHER_LIST_FILTER_PARAM,
	filterByType: ["dropdown", "dropdownExclude", "isIn", "isNotIn"],
	filterByValue: [],
	group: FilterCategory.FREQUENTLY_USED,
};

const attendees: IFilter = {
	name: "attendees",
	filterParam: "li_event_entry.attendees",
	filterByType: ["isEmpty", "isNotEmpty", "greaterEqual", "lessEqual", "between"],
	filterByValue: [],
	group: FilterCategory.EVENTS,
};

export const sourceName: IFilter = {
	name: "sourceName",
	filterParam: "list_person.sourceName",
	filterByType: ["textContains", "textDoesNotContain"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const addedAt: IFilter = {
	name: "addedAt",
	filterParam: "list_person.createdAt",
	filterByType: ["greaterEqualDate", "lessEqualDate", "betweenDate"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const addedToCampaignAt: IFilter = {
	name: "addedToCampaignAt",
	filterParam: "list_person.addedToCampaignAt",
	filterByType: ["greaterEqualDate", "lessEqualDate", "betweenDate"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const roleChangeType: IFilter = {
	name: "roleChangeType",
	filterParam: "prospect.jobChangeOrPromotion",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const roleChange: IFilter = {
	name: "roleChangeDate",
	filterParam: "prospect.startedCurrentPosition",
	filterByType: ["greaterEqualDate", "lessEqualDate", "betweenDate"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const assignedStatus: IFilter = {
	name: "assignedStatus",
	filterParam: "list_person.assignStatus",
	filterByType: ["dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const lastNodeType: IFilter = {
	name: "lastNodeType",
	filterParam: "list_person.lastNodeType",
	filterByType: ["dropdown", "dropdownExclude", "isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const lastScheduledAt: IFilter = {
	name: "lastScheduledAt",
	filterParam: "list_person.lastScheduledAt",
	filterByType: ["greaterEqualDate", "lessEqualDate", "betweenDate"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const personInCrm: IFilter = {
	name: "personInCrm",
	filterParam: "crm_prospect.id",
	filterByType: ["isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const companyInCrm: IFilter = {
	name: "companyInCrm",
	filterParam: "crm_organization.id",
	filterByType: ["isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const deepResearchResponse: IFilter = {
	name: "deepResearchResponse",
	filterParam: "deep_research_response.id",
	filterByType: ["isEmpty", "isNotEmpty"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

const fitAssessment: IFilter = {
	name: "fitAssessment",
	filterParam: "deep_research_response.fitAssessment",
	filterByType: ["isEmpty", "isNotEmpty", "dropdown", "dropdownExclude"],
	filterByValue: [],
	group: FilterCategory.ADDITIONAL_ATTRIBUTES,
};

export const AssignedTabFilters: IFilter[] = [assignedStatus, lastNodeType, lastScheduledAt];

export const GeneralFilter: IFilter[] = [
	overallScore,
	name,
	title,
	about,
	seniority,
	email,
	linkedinUrl,
	country,
	city,
	state,
	company,
	connections,
	industry,
	companyCountry,
	companyState,
	companyCity,
	countryBranch,
	stateBranch,
	cityBranch,
	companyLinkedinUrl,
	foundedYear,
	website,
	estimatedNumEmployees,
	reportedEmployees,
	previousEmployer,
	list,
	companyOtherList,
	exclusionReason,
	inCampaign,
	language,
	companyCategory,
	personaCategory,
	sourceName,
	addedAt,
	addedToCampaignAt,
	roleChange,
	roleChangeType,
	companyCategoryType,
	personInCrm,
	companyInCrm,
	deepResearchResponse,
	fitAssessment,
	genderProbability,
];

export const FrequentlyUsedFiltersConfig: IFilter[] = [
	title,
	seniority,
	country,
	industry,
	estimatedNumEmployees,
	companyCountry,
];

export const AdditionalColumnsFiltersConfig: IFilter[] = [
	reportedEmployees,
	about,
	city,
	state,
	company,
	companyState,
	companyCity,
	companyLinkedinUrl,
	foundedYear,
	countryBranch,
	stateBranch,
	cityBranch,
	previousEmployer,
	language,
];

export const LiEventFilter: IFilter[] = [attendees, event];
